export enum SOCIAL_TYPE {
  fb = 'fb',
  ig = 'ig',
  line = 'line',
}

export const social_types = [SOCIAL_TYPE.line, SOCIAL_TYPE.fb, SOCIAL_TYPE.ig];
